module.controller('viewStatementsCtrl', ['$scope', '$http', '$stateParams', 'Session', 'accountService', 'baseURI', 'OVERLAY',
  function ($scope, $http, $stateParams, Session, accountService, baseURI, OVERLAY){
    $scope.overlay = OVERLAY['member.home.profile/statements'];
    $scope.noSidebar = true;
    $scope.cancel = true;
    $scope.showList = true;
    $scope.nestedBack = back;

    var vm = this;
    var account = accountService.getAccount($stateParams.username);
    var usernameParam = '/?Username=' + account.username;

    vm.get = get;
    vm.loading = true;

    init();

    // Get list of periods from API
    function init() {
      $http({
        url: baseURI + 'statements' + usernameParam,
        method: 'GET',
      }).then(function (resp){
        var data = resp.data;

        vm.loading = false;
        vm.periods = parsePeriods(data.Data.Periods);
      }).catch(function(error){
        vm.loading = false;
        console.log(error);
      });
    }

    // Get a specific statement and display the pdf
    function get(period) {
      $scope.showList = false;
      $scope.showBack = true;
      vm.loading = true;
      $http({
        url: baseURI + 'statement/' + period + usernameParam,
        method: 'GET',
        responseType: 'arraybuffer'
      }).then(function (resp){
        var data = resp.data;

        var file = new Blob([data], {type: 'application/pdf'});
        var fileURL = URL.createObjectURL(file);
        vm.pdfSrc = fileURL;
        vm.loading = false;
      }).catch(function(error){
        $scope.showList = true;
        $scope.showBack = false;
        vm.loading = false;
        console.log(error);
      });
    }

    function back() {
      $scope.showList = true;
      $scope.showBack = false;
      vm.loading = false;
      vm.pdfSrc = '';
    }

    function parsePeriods(periods) {
      periods.sort(function(a, b) {
        return b-a;
      });

      var periodsNormalized = periods.map(function(period) {
        var label = setPeriodLabel(period);
        return { date: period, label: label };
      });

      var periodsObj = {};

      for (var i = 0; i < periodsNormalized.length; i++) {
        var year = periodsNormalized[i].date.substring(0, 4);

        if (periodsObj[year] === undefined) {
          periodsObj[year] = [];
        }

        periodsObj[year].push(periodsNormalized[i]);
      }

      var periodsSorted = Object.keys(periodsObj).sort(function(a, b) {
        return b-a;
      }).map(function(key) {
        var obj = {};
        obj.year = key;
        obj.periods = periodsObj[key];
        return obj;
      });

      return periodsSorted;
    }

    function setPeriodLabel(period) {
      var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      var monthNumber = period.substring(4, 6);
      var year = period.substring(0, 4);

      return months[monthNumber - 1] + " " + year;
    }

  }]);
